export enum RequestStatus {
  PENDING,
  FULFILLED,
  REJECTED,
};
